import React from "react";
import { BarChart3, ShoppingBag, TrendingUp, Users } from "lucide-react";
import { AdminPageHeader, Badge, ListRow, Page, Panel, StatCard, StatGrid } from "../AdminKit";

const channels = [
  { name: "검색 유입", sales: "₩ 42.8M", rate: "32%" },
  { name: "AI 추천", sales: "₩ 31.2M", rate: "24%" },
  { name: "쿠폰 캠페인", sales: "₩ 18.4M", rate: "14%" },
  { name: "재구매", sales: "₩ 27.9M", rate: "21%" },
];

export default function AdminAnalytics() {
  return (
    <Page>
      <AdminPageHeader title="통계 분석" description="매출, 전환율, 유입 채널, 인기 상품 흐름을 추적합니다." />
      <StatGrid>
        <StatCard><TrendingUp size={24} /><span>월 매출</span><strong>₩ 128.4M</strong></StatCard>
        <StatCard><ShoppingBag size={24} /><span>주문 전환율</span><strong>4.82%</strong></StatCard>
        <StatCard><Users size={24} /><span>재구매율</span><strong>36.5%</strong></StatCard>
        <StatCard><BarChart3 size={24} /><span>객단가</span><strong>₩ 284K</strong></StatCard>
      </StatGrid>
      <Panel>
        <header><h2>채널별 매출</h2><Badge>이번 달</Badge></header>
        {channels.map((channel) => (
          <ListRow key={channel.name} $columns="1fr 150px 100px">
            <div><strong>{channel.name}</strong><span>전체 매출 기여도</span></div>
            <strong>{channel.sales}</strong>
            <Badge>{channel.rate}</Badge>
          </ListRow>
        ))}
      </Panel>
    </Page>
  );
}
